import { SVGProps } from "react";

// "On going" — caja con play (estado open/en curso).
export function CubePlay(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="60" height="60" rx="6" fill="#FFFBE6" />
      <path
        d="M48 30.375C42.6848 30.375 38.375 34.6848 38.375 40C38.375 45.3152 42.6848 49.625 48 49.625C53.3152 49.625 57.625 45.3152 57.625 40C57.625 34.6848 53.3152 30.375 48 30.375ZM48 47.9922C43.5871 47.9922 40.0078 44.4129 40.0078 40C40.0078 35.5871 43.5871 32.0078 48 32.0078C52.4129 32.0078 55.9922 35.5871 55.9922 40C55.9922 44.4129 52.4129 47.9922 48 47.9922Z"
        fill="#FF8F1F"
      />
      <path
        opacity="0.1"
        d="M48 32.0078C43.5871 32.0078 40.0078 35.5871 40.0078 40C40.0078 44.4129 43.5871 47.9922 48 47.9922C52.4129 47.9922 55.9922 44.4129 55.9922 40C55.9922 35.5871 52.4129 32.0078 48 32.0078ZM51.5256 40.1332L46.8334 43.5471C46.8077 43.5656 46.7774 43.5766 46.7458 43.579C46.7142 43.5813 46.6825 43.575 46.6543 43.5605C46.6262 43.5461 46.6025 43.5242 46.5859 43.4972C46.5694 43.4701 46.5606 43.4391 46.5605 43.4074V36.584C46.5604 36.5522 46.5691 36.5211 46.5856 36.494C46.6022 36.4669 46.6259 36.4449 46.6541 36.4304C46.6824 36.416 46.7141 36.4096 46.7457 36.4121C46.7774 36.4145 46.8077 36.4257 46.8334 36.4443L51.5256 39.8561C51.5478 39.8717 51.5658 39.8925 51.5783 39.9166C51.5908 39.9407 51.5973 39.9675 51.5973 39.9946C51.5973 40.0218 51.5908 40.0485 51.5783 40.0726C51.5658 40.0968 51.5478 40.1175 51.5256 40.1332Z"
        fill="#FFFBE6"
      />
      <path
        d="M51.5256 39.8553L46.8334 36.4436C46.8077 36.4249 46.7774 36.4137 46.7457 36.4113C46.7141 36.4088 46.6824 36.4152 46.6541 36.4296C46.6259 36.4441 46.6022 36.4661 46.5856 36.4932C46.5691 36.5203 46.5604 36.5515 46.5605 36.5832V43.4067C46.5606 43.4383 46.5694 43.4694 46.5859 43.4964C46.6025 43.5234 46.6262 43.5453 46.6543 43.5598C46.6825 43.5742 46.7142 43.5806 46.7458 43.5782C46.7774 43.5758 46.8077 43.5648 46.8334 43.5463L51.5256 40.1324C51.5477 40.1168 51.5658 40.096 51.5783 40.0719C51.5908 40.0478 51.5973 40.021 51.5973 39.9939C51.5973 39.9667 51.5908 39.94 51.5783 39.9158C51.5658 39.8917 51.5477 39.871 51.5256 39.8553Z"
        fill="#FF8F1F"
      />
      <path
        d="M50.8258 17.49L30.0008 30M30.0008 30L9.17578 17.49M30.0008 30V53.725"
        stroke="#FF8F1F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.3371 27.5225V21.9825C52.3403 20.6527 51.9875 19.3463 51.3153 18.199C50.6432 17.0516 49.6761 16.105 48.5146 15.4575L33.6221 7.19001C32.5143 6.57354 31.2675 6.25 29.9996 6.25C28.7318 6.25 27.485 6.57354 26.3771 7.19001L11.4846 15.455C10.3228 16.1027 9.3555 17.0497 8.68331 18.1975C8.01111 19.3454 7.65852 20.6523 7.66214 21.9825V38.0175C7.65896 39.3473 8.01177 40.6537 8.68394 41.8011C9.35611 42.9485 10.3231 43.895 11.4846 44.5425L26.3771 52.81C27.485 53.4265 28.7318 53.75 29.9996 53.75C31.2675 53.75 32.5143 53.4265 33.6221 52.81L39.9271 49.31"
        stroke="#FF8F1F"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
